import { render, staticRenderFns } from "./BannedWord.vue?vue&type=template&id=7cc118a6&scoped=true"
import script from "./BannedWord.vue?vue&type=script&lang=js"
export * from "./BannedWord.vue?vue&type=script&lang=js"
import style0 from "./BannedWord.vue?vue&type=style&index=0&id=7cc118a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc118a6",
  null
  
)

export default component.exports